import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
const SPACE_PINNED_THREADS_QUERY_PATH = '/rest/spaces/{space_uuid}/pins/threads';
const SPACE_SCHEDULED_THREADS_QUERY_PATH = '/rest/spaces/{space_uuid}/scheduled_threads';
function getSpacePinnedThreadsQueryKeyParts(spaceUuid) {
    return spaceUuid
        ? [SPACE_PINNED_THREADS_QUERY_PATH, spaceUuid]
        : [SPACE_PINNED_THREADS_QUERY_PATH];
}
function getSpaceScheduledThreadsQueryKeyParts(spaceUuid) {
    return spaceUuid
        ? [SPACE_SCHEDULED_THREADS_QUERY_PATH, spaceUuid]
        : [SPACE_SCHEDULED_THREADS_QUERY_PATH];
}
export const getAllSpacesQueryKey = () => QueryClientHelper.makeQueryKey('/rest/spaces', 'list', 'all');
export const getOrgPinnedSpacesQueryKey = () => QueryClientHelper.makeQueryKey('/rest/spaces/org/pins');
export const getListAtMentionsSpacesQueryKey = () => QueryClientHelper.makeQueryKey('/rest/spaces/mentions');
export const getUserPinnedSpacesQueryKey = (userEmail) => userEmail
    ? QueryClientHelper.makeQueryKey('/rest/spaces/user-pins', userEmail)
    : QueryClientHelper.makeQueryKey('/rest/spaces/user-pins');
export const getSpacesLandingQueryKey = (searchTerm) => searchTerm == null
    ? QueryClientHelper.makeQueryKey('/rest/spaces/landing')
    : QueryClientHelper.makeQueryKey('/rest/spaces/landing', { search_term: searchTerm });
export const getSpacesLandingV2QueryKey = (searchTerm) => searchTerm == null
    ? QueryClientHelper.makeQueryKey('/rest/spaces/landing/v2')
    : QueryClientHelper.makeQueryKey('/rest/spaces/landing/v2', { search_term: searchTerm });
export const getSpacesLandingV2ScopedQueryKey = ({ limit, sections, ordered, }) => QueryClientHelper.makeQueryKey('/rest/spaces/landing/v2', { limit, sections, ordered });
export const getSpacesLandingV2SectionQueryKey = (sectionKey, searchTerm) => searchTerm == null
    ? QueryClientHelper.makeQueryKey('/rest/spaces/landing/v2', 'section', sectionKey)
    : QueryClientHelper.makeQueryKey('/rest/spaces/landing/v2', 'section', sectionKey, {
        search_term: searchTerm,
    });
const getSpacePinnedThreadsQueryKeyPrefix = (spaceUuid) => QueryClientHelper.makeQueryKey(...getSpacePinnedThreadsQueryKeyParts(spaceUuid));
export const getSpacePinnedThreadsQueryKey = ({ spaceUuid, threadType, searchTerm, limit, filterByUser, } = {}) => {
    const params = {
        ...(threadType ? { threadType } : {}),
        ...(searchTerm ? { searchTerm } : {}),
        ...(limit !== undefined ? { limit } : {}),
        ...(filterByUser ? { filterByUser } : {}),
    };
    if (Object.keys(params).length === 0)
        return getSpacePinnedThreadsQueryKeyPrefix(spaceUuid);
    return QueryClientHelper.makeQueryKey(...getSpacePinnedThreadsQueryKeyParts(spaceUuid), params);
};
const getSpaceScheduledThreadsQueryKeyPrefix = (spaceUuid) => QueryClientHelper.makeQueryKey(...getSpaceScheduledThreadsQueryKeyParts(spaceUuid));
export const getSpaceScheduledThreadsQueryKey = ({ spaceUuid, searchTerm, filterByUser, } = {}) => {
    const params = {
        ...(searchTerm ? { searchTerm } : {}),
        ...(filterByUser ? { filterByUser } : {}),
    };
    if (Object.keys(params).length === 0)
        return getSpaceScheduledThreadsQueryKeyPrefix(spaceUuid);
    return QueryClientHelper.makeQueryKey(...getSpaceScheduledThreadsQueryKeyParts(spaceUuid), params);
};
export const getSpaceLatestUpdateQueryKey = (spaceUuid) => QueryClientHelper.makeQueryKey('/rest/spaces/{space_uuid}/latest_update', spaceUuid);
const SPACE_PINNED_FILES_QUERY_PATH = '/rest/spaces/{space_uuid}/pins/files/batch_get';
/** Prefix shared by every per-ids pinned-files query of one space — pin/unpin
 * mutations patch and invalidate all of them through this. */
export const getSpacePinnedFilesQueryKeyPrefix = (spaceUuid) => QueryClientHelper.makeQueryKey(SPACE_PINNED_FILES_QUERY_PATH, spaceUuid);
export const getSpacePinnedFilesQueryKey = (spaceUuid, assetIdsKey) => QueryClientHelper.makeQueryKey(SPACE_PINNED_FILES_QUERY_PATH, spaceUuid, assetIdsKey);
//# sourceMappingURL=spacesKeys.js.map